import { useState } from "react";
import { useNavigate } from "react-router-dom";
import NavBar from "../common/NavBar";
import Footer from "../common/Footer";
import { useTranslation } from "react-i18next";

const Register = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();

  // Determine the API base URL based on the environment
  const getApiBaseUrl = () => {
    // Use the REACT_APP_API_URL from .env, fallback to localhost if not set
    return process.env.REACT_APP_API_URL || "http://localhost:8000";
  };

  const handleRegister = async (e) => {
    e.preventDefault();
  
    if (password !== confirmPassword) {
      alert(t("passwords_do_not_match"));
      return;
    }
  
    try {
      const response = await fetch(`${getApiBaseUrl()}/api/users/register/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password, password2: password }),
      });
  
      if (!response.ok) {
        throw new Error(t("registration_failed"));
      }
  
      // Redirect to login page after successful registration
      navigate("/login");
    } catch (error) {
      console.error(t("error_registering"), error);
      alert(t("registration_failed"));
    }
  };
  return (
    <div className="flex flex-col min-h-screen">
      <NavBar />

      {/* Centered Form */}
      <div className="flex-grow flex items-center justify-center px-4 pt-20">
        <div className="w-full max-w-[300px] p-6 border rounded-lg shadow-lg">
          <h2 className="text-2xl font-bold text-center mb-4">{t("register")}</h2>

          <form onSubmit={handleRegister} className="flex flex-col gap-4">
            {/* Email Field */}
            <input
              type="email"
              placeholder={t("email")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="border p-2 rounded"
              required
            />

            {/* Password Field */}
            <input
              type="password"
              placeholder={t("password")}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="border p-2 rounded"
              required
            />

            {/* Confirm Password Field */}
            <input
              type="password"
              placeholder={t("repeat_password")}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="border p-2 rounded"
              required
            />

            {/* Register Button */}
            <button type="submit" className="bg-blue-500 text-white p-2 rounded font-bold">
              {t("register")}
            </button>
          </form>

          {/* Login Link */}
          <p className="text-center mt-4">
            <span>{t("already_have_account")}</span>
            <button onClick={() => navigate("/login")} className="text-blue-600 underline">
              {t("login_here")}
            </button>
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Register;